import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import QuoteModal from '@/components/PowerOcean/Home/QuoteModal';

export default function B({ langKey }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');
    const [showMore, setShowMore] = useState(false);
    const [showQuoteModal, setShowQuoteModal] = useState(false);

    const handleLearMore = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'solution_button',
                list_name: t('secB_title'),
                button_name: t('secA_btn'),
            });
        } catch (e) {
            console.error(e);
        } finally {
            if (langKey === 'solarspeicher') {
                const target = document.querySelector('.power-ocean-collection-N') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target?.offsetTop,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            setShowQuoteModal(true);
        }
    };

    return (
        <div className={`power-ocean-collection-B ${css['power-ocean-collection-B']}`}>
            <div className="text-box">
                <p className="title">{t('secB_title')}</p>
                <p className="desc">{t('secB_desc')}</p>
                <div className="collapse-box" onClick={() => setShowMore(!showMore)}>
                    {showMore && <p className="list-desc">{t('secB_text')}</p>}
                    <div className="list-more">
                        <span className="more-text">{t('secB_more')}</span>
                        <span className={`more-icon ${showMore ? 'up' : 'down'}`}>
                            <EFArrowDown width="14px" height="14px" />
                        </span>
                    </div>
                </div>
            </div>
            <div className="img">
                <NextImage src={require('@publicLocal/power-ocean/collection/pc/de/2.jpg')} alt={t('secB_title')} aria-label={t('secB_title')} />
            </div>
            {langKey !== 'solarspeicher' && (
                <p className="pop-btn" onClick={handleLearMore}>
                    {t('secA_btn')}
                </p>
            )}
            {showQuoteModal && <QuoteModal callback={() => setShowQuoteModal(false)} initType={0} />}
        </div>
    );
}
